import React from "react";
import { DiscountTimer } from "./DiscountTimer";
import { CurrencyContext } from "../Context/Currency";
import { RenderContext } from "../Context/Ssr";
import { CatalogContext } from "../Translator/withTranslation";
import { LocaleContext } from "../Context/Locale";


const AccommodationDiscountTimerComponent = (props) => {

    return ( 
        <div>
            <DiscountTimer {...props} />
        </div>
    );
}

export const AccommodationDiscountTimer = (initialProps, context) => {
return (
    <LocaleContext.Provider value={initialProps.locale}>
      <CatalogContext.Provider value={initialProps.catalog}>
        <RenderContext.Provider value={context}>
          <CurrencyContext.Provider value={initialProps.currency}>
            <AccommodationDiscountTimerComponent {...initialProps} />
          </CurrencyContext.Provider>
        </RenderContext.Provider>
      </CatalogContext.Provider>
    </LocaleContext.Provider>
  );
}